import React from "react";
import { withTranslation } from "react-i18next"; // Import withTranslation HOC
import { APPOINTMENT_URL } from "./url/url";

class Banner extends React.Component {
    render() {
            const { t } = this.props;
            // Lazy load ReviewCarousel to avoid circular imports
            const ReviewCarousel = React.lazy(() => import("./ReviewCarousel"));
            return (
                <div>
                    <header className="masthead">
                        <div className="container">
                            <div className="intro-text img/header-bg.jpg">
                                <div className="intro-lead-in text-uppercase">
                                    {t("home.message")}
                                </div>
                                <div className="intro-lead-in ">
                                    {t("home.body")}
                                </div>
                                <div className="intro-heading text-uppercase">0451516598</div>
                                <a
                                    className="btn btn-primary btn-xl text-uppercase js-scroll-trigger"
                                    href={APPOINTMENT_URL}
                                >
                                    {t("home.button")} {/* Translate button text */}
                                </a>
                                {/* Review cards under Home button */}
                                <React.Suspense fallback={null}>
                                    <ReviewCarousel />
                                </React.Suspense>
                            </div>
                        </div>
                    </header>
                </div>
            );
    }
}

export default withTranslation("global")(Banner)